import {
  IDateRangeValue,
  IHierarchyValue,
  IOperatorValue,
  ISelectedDateRangeInfo,
  ISelectedFacetInfo,
  ISelectedHierarchyInfo,
  ISelectedOperatorInfo,
} from '../types';

export class TypeInstanceOf {
  public static OperatorInfo(obj: unknown): obj is ISelectedOperatorInfo {
    return obj !== null && typeof obj === 'object' && 'operatorInfo' in obj && 'operand' in obj && 'item' in obj;
  }

  public static DateRangeInfo(obj: unknown): obj is ISelectedDateRangeInfo {
    return obj !== null && typeof obj === 'object' && 'dateRange' in obj && 'item' in obj;
  }

  public static FacetInfo(obj: unknown): obj is ISelectedFacetInfo {
    return obj !== null && typeof obj === 'object' && 'facets' in obj && 'item' in obj;
  }

  public static HierarchyInfo(obj: unknown): obj is ISelectedHierarchyInfo {
    return obj !== null && typeof obj === 'object' && 'hierarchies' in obj && 'item' in obj;
  }

  public static HierarchyValue(obj: unknown): obj is IHierarchyValue {
    return obj !== null && typeof obj === 'object' && 'name' in obj && 'key' in obj && 'value' in obj;
  }

  public static DateRangeValue(obj: unknown): obj is IDateRangeValue {
    return obj !== null && typeof obj === 'object' && 'startDate' in obj && 'endDate' in obj;
  }

  public static OperatorValue(obj: unknown): obj is IOperatorValue {
    return obj !== null && typeof obj === 'object' && 'operator' in obj && 'operand' in obj;
  }
}
